      <div  *ngIf="!show"  >

<div class="login-page">
  <div class="form-container">
    <div class="vesax-forgot">
      <!-- Logo -->
      <div class="login-logo">
        <img
          src="../../../../../assets/img/Idex_Logo-removebg-preview.png"
          alt="IDEX Logo"
        />
      </div>

      <!-- Heading -->
      <div class="signin-head">
        <h4>Vendor MSME Status <span>Declaration 2026</span></h4>
        <p class="form-subtitle">
          Please fill this form accurately. All fields marked
          <span style="color: #dc2626">*</span> are mandatory.
        </p>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-state" aria-live="polite">
        <div class="loading-spinner"></div>
        <p>Loading vendor information...</p>
      </div>

      <!-- Form -->
      <form
        [formGroup]="msmeForm"
        (ngSubmit)="submitMsmeForm()"
        *ngIf="!isLoading"   
        novalidate
      > 

     
        <!-- Global error summary (appears after failed submission) -->
        <!-- <div
          *ngIf="formSubmitted && msmeForm.invalid"
          class="error-message"
          role="alert"
          aria-live="assertive"
        >
          <strong>Please fix the errors below</strong> – all marked fields are
          required.
        </div> -->

        <!-- MSME Registration Question -->
        <div class="msme-question-block">
          <p class="question-text">
            <span class="step-badge" aria-hidden="true">1</span>
            Is your organization registered under the MSME Act 2006?
            <span class="star_class">*</span>
          </p>

          <div class="radio-group">
            <label class="radio-option" for="msmeYes">
              <input
                id="msmeYes"
                type="radio"
                value="Yes"
                formControlName="msmeRegistered"
                (change)="onMsmeChange('Yes')"
              />
              Yes
            </label>
            <label class="radio-option" for="msmeNo">
              <input
                id="msmeNo"
                type="radio"
                value="No"
                formControlName="msmeRegistered"
                (change)="onMsmeChange('No')"
              />
              No
            </label>
          </div>

          <div
            class="invalid-feedback"
            *ngIf="formSubmitted && msmeForm.get('msmeRegistered')?.invalid"
          >
            Please select an option
          </div>
        </div>

        <!-- ── SHOW IF YES ──────────────────────────────────── -->
        <div class="expanded-fields" [hidden]="!showFields">
          <div class="section-label">Vendor Details</div>

          <!-- Row 1: Vendor Name & Supplier Code -->
          <div class="form-row">
            <div class="form-group">
              <label for="vendorName"
                >Vendor Name <span class="star_class">*</span></label
              >
              <input
                id="vendorName"
                class="form-control"
                type="text"
                formControlName="vendorName"
                placeholder="Auto-filled from records"
                readonly
                [class.is-invalid]="
                  formSubmitted && msmeForm.get('vendorName')?.invalid
                "
              />
              <div
                class="invalid-feedback"
                *ngIf="formSubmitted && msmeForm.get('vendorName')?.invalid"
              >
                Vendor name is required
              </div>
            </div>

            <div class="form-group">
              <label for="supplierCode"
                >Supplier Code at IDEX India
                <span class="star_class">*</span></label
              >
              <input
                id="supplierCode"
                class="form-control"
                type="text"
                formControlName="supplierCode"
                placeholder="Auto-filled from records"
                readonly
                [class.is-invalid]="
                  formSubmitted && msmeForm.get('supplierCode')?.invalid
                "
              />
              <div
                class="invalid-feedback"
                *ngIf="formSubmitted && msmeForm.get('supplierCode')?.invalid"
              >
                Supplier code is required
              </div>
            </div>
          </div>

          <div class="section-label">Registration Number</div>

          <!-- Row 2: GSTIN & Udyam -->
          <div class="form-row-full">
            <!-- <div class="form-group">
              <label for="gstNumber">GSTIN Number <span class="star_class">*</span></label>
              <input
                id="gstNumber"
                class="form-control"
                type="text"
                formControlName="gstNumber"
                placeholder="e.g. 22AAAAA0000A1Z5"
                [class.is-invalid]="formSubmitted && msmeForm.get('gstNumber')?.invalid"
              />
              <div
                class="invalid-feedback"
                *ngIf="formSubmitted && msmeForm.get('gstNumber')?.invalid"
              >
                GSTIN is required
              </div>
            </div> -->

            <div class="form-group">
              <label for="udyamNumber"
                >Udyam / MSME Reg. Number
                <span class="star_class">*</span></label
              >
        <input
  id="udyamNumber"
  class="form-control"
  type="text"
  formControlName="udyamNumber"
  (input)="msmeForm.get('udyamNumber')?.setValue($event.target.value.toUpperCase(), {emitEvent:false})"
/>
            <div
  class="invalid-feedback"
  *ngIf="formSubmitted && msmeForm.get('udyamNumber')?.invalid"
>
  <ng-container *ngIf="msmeForm.get('udyamNumber')?.errors?.['required']">
    Udyam number is required
  </ng-container>

  <ng-container *ngIf="msmeForm.get('udyamNumber')?.errors?.['pattern']">
    Enter valid Udyam number (Example: UDYAM-MH-12-0001234)
  </ng-container>
</div>
            </div>
          </div>

          <div class="section-label">Classification</div>

          <!-- Row 3: Activity Type & Enterprise Type -->
          <div class="form-row">
            <div class="form-group">
              <label for="activityType"
                >Type of Activity <span class="star_class">*</span></label
              >
              <select
                id="activityType"
                class="form-control"
                formControlName="activityType"
              >
                <option value="">Select activity type</option>
                <option value="Manufacturing">Manufacturing</option>
                <option value="Service">Service</option>
                <option value="Trading">Trading</option>
              </select>
              <div
                class="invalid-feedback"
                *ngIf="formSubmitted && msmeForm.get('activityType')?.invalid"
              >
                Please select an activity type
              </div>
            </div>

            <div class="form-group">
              <label for="enterpriseType"
                >Type of Enterprise <span class="star_class">*</span></label
              >
              <select
                id="enterpriseType"
                class="form-control"
                formControlName="enterpriseType"
                [class.is-invalid]="
                  formSubmitted && msmeForm.get('enterpriseType')?.invalid
                "
              >
                <option value="">Select enterprise type</option>
                <option value="Micro">Micro</option>
                <option value="Small">Small</option>
                <option value="Medium">Medium</option>
              </select>
              <div
                class="invalid-feedback"
                *ngIf="formSubmitted && msmeForm.get('enterpriseType')?.invalid"
              >
                Please select an enterprise type
              </div>
            </div>
          </div>

          <div class="section-label">Contact Information</div>

          <!-- Row 4: Phone & Email -->
          <div class="form-row">
            <div class="form-group">
              <label for="phone"
                >Phone Number <span class="star_class">*</span></label
              >
              <input
                id="phone"
                class="form-control"
                type="tel"
                formControlName="phone"
                placeholder="10-digit mobile number"
                [class.is-invalid]="
                  formSubmitted && msmeForm.get('phone')?.invalid
                "
              />
              <div
                class="invalid-feedback"
                *ngIf="formSubmitted && msmeForm.get('phone')?.invalid"
              >
                <ng-container
                  *ngIf="msmeForm.get('phone')?.errors?.['required']"
                >
                  Phone number is required
                </ng-container>
                <ng-container
                  *ngIf="msmeForm.get('phone')?.errors?.['pattern']"
                >
                  Please enter a valid 10-digit mobile number
                </ng-container>
              </div>
            </div>

            <div class="form-group">
              <label for="email"
                >Email Address <span class="star_class">*</span></label
              >
              <input
                id="email"
                class="form-control"
                type="email"
                formControlName="email"
                placeholder="official@company.com"
                [class.is-invalid]="
                  formSubmitted && msmeForm.get('email')?.invalid
                "
              />
              <div
                class="invalid-feedback"
                *ngIf="formSubmitted && msmeForm.get('email')?.invalid"
              >
                <ng-container
                  *ngIf="msmeForm.get('email')?.errors?.['required']"
                >
                  Email address is required
                </ng-container>
                <ng-container *ngIf="msmeForm.get('email')?.errors?.['email']">
                  Enter a valid email address (e.g., name@example.com)
                </ng-container>
              </div>
            </div>
          </div>

          <div class="section-label">Supporting Document</div>

          <!-- Row 5: File Upload - Full Width -->
          <div class="form-row-full">
            <div class="form-group">
              <label for="documentUpload"
                >Upload MSME Certificate
                <span class="star_class">*</span></label
              >
              <input
                id="documentUpload"
                type="file"
                class="form-control"
                (change)="getFile($event)"
                accept=".pdf,.jpeg,.jpg,.png"
                [class.is-invalid]="
                  formSubmitted && msmeForm.get('documentUpload')?.invalid
                "
              />
              <p class="field-hint">
                Accepted formats: PDF, JPG, PNG · Max size: 5MB
              </p>
              <div
                class="invalid-feedback"
                *ngIf="formSubmitted && msmeForm.get('documentUpload')?.invalid"
              >
                Please upload your MSME certificate
              </div>
            </div>
          </div>
        </div>
        <!-- ── END YES BLOCK ───────────────────────────────── -->

        <!-- ── SHOW IF NO ───────────────────────────────────── -->
        <div
          class="no-declaration-block"
          *ngIf="msmeForm.get('msmeRegistered')?.value === 'No'"
        >
          <span class="check-icon" aria-hidden="true"></span>
          <p>
            <strong>Declaration Noted</strong>
            You have confirmed that your organization is not registered under
            the MSME Act 2006. Please submit to complete your declaration.
          </p>
        </div>
        <div *ngIf="msmeForm.get('msmeRegistered')?.value === 'No'" class="form-row">

  <div class="form-group">
    <label>Phone Number <span class="star_class">*</span></label>
    <input
      type="tel"
      class="form-control"
      formControlName="phone"
      placeholder="10-digit mobile number"
    />

    <div class="invalid-feedback"
      *ngIf="formSubmitted && msmeForm.get('phone')?.invalid">
      Enter valid phone number
    </div>
  </div>

  <div class="form-group">
    <label>Email Address <span class="star_class">*</span></label>
    <input
      type="email"
      class="form-control"
      formControlName="email"
      placeholder="official@company.com"
    />

    <div class="invalid-feedback"
      *ngIf="formSubmitted && msmeForm.get('email')?.invalid">
      Enter valid email
    </div>
  </div>

</div>
        <!-- ── END NO BLOCK ───────────────────────────────── -->

        <!-- Buttons -->
        <!-- Buttons -->
        <div class="form-actions" *ngIf="!isLoading">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isSubmitting"
          >
            <span
              *ngIf="isSubmitting"
              class="spinner"
              aria-hidden="true"
            ></span>
            <span *ngIf="isSubmitting">Submitting...</span>
            <span *ngIf="!isSubmitting">Submit</span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            (click)="resetForm()"
            *ngIf="showFields || msmeForm.get('msmeRegistered')?.value === 'No'"
          >
            Reset
          </button>
        </div>
      </form>

      <!-- display fetched MSME forms -->
      <!-- <div *ngIf="msmeRecords.length" class="mt-4">
        <h4>Previously submitted MSME forms</h4>
        <ul>
          <li *ngFor="let rec of msmeRecords">
            ID {{ rec.id }} – {{ rec.vendorName }} – {{ rec.msmeNumber }}
          </li>
        </ul>
      </div> -->
      <!-- <div *ngIf="!msmeRecords.length && msmeError" class="mt-4 error-message">
        {{ msmeError }}
      </div> -->
    </div>
  </div>
</div>
         </div>

<div *ngIf="show" class="thank-you-message">
  <h2>Thank You!</h2>
  <p>Your form has been submitted successfully.</p>
</div>
